module.exports = __webpack_public_path__ + "static/media/pic1.28e1f884.jpg";